export default {
  title: 'Recevoir des prospectus mensuels automatiques',
  status: {
    enabled: 'Activé',
    disabled: 'Désactivé',
  },
  opt_out: {
    on_hint: 'Votre offre FoodAmigos inclut 500 prospectus gratuits par mois. Désactivez pour ne plus en recevoir.',
    off_hint: 'Les prospectus automatiques sont en pause. Activez pour reprendre dès le prochain cycle.',
    confirm_off: {
      title: 'Désactiver les prospectus automatiques ?',
      body: 'En désactivant, {{location}} ne recevra plus de prospectus automatiques à partir du prochain cycle. Les commandes en cours ne sont pas affectées.',
      confirm: 'Désactiver',
      cancel: 'Laisser activé',
    },
  },
  approved_design: {
    label: 'Design approuvé pour les prospectus mensuels',
    auto_option: 'Automatique (dernière commande)',
    flyer_slot: 'Prospectus {{slot}}',
    custom: 'Personnalisé',
    untitled: 'Sans titre',
    invalid_warning:
      "Le design enregistré n'est plus disponible. Le dernier prospectus commandé sera utilisé jusqu'à ce que vous en choisissiez un nouveau.",
  },
  toasts: {
    failed_to_load: 'Échec du chargement des paramètres de prospectus automatique',
    failed_to_save: "Échec de l'enregistrement des modifications",
    saved: 'Modifications enregistrées',
  },
};
